/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {connect} from 'preact-redux';
import {Component, h} from 'preact';
import {PropTypes} from 'preact-compat';

class Notification extends Component {
  render() {
    if (this.props.message && this.props.level.toLowerCase() !== 'info' && this.props.level.toLowerCase() !== 'success') {
      console.log(this.props.level, this.props.title, this.props.message);
    }

    return (
      <div>
      </div>
    );
  }

  componentDidUpdate() {
  }
}

Notification.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  level: PropTypes.string
};

const mapStateToProps = (state) => {
  return state.notification || {};
};

const NotificationContainer = connect(
  mapStateToProps
)(Notification);

export default NotificationContainer;